import { css, SerializedStyles } from '@emotion/react';

export const useStyles = (): SerializedStyles => css`
  .title-container {
    display: flex;
    justify-content: space-between;
  }
`;
